import 'magnific-popup';

export default function modal() {
    $('.animated-popup').magnificPopup({
        removalDelay: 500,
        callbacks: {
            beforeOpen: function () {
                this.st.mainClass = this.st.el.attr('data-effect');
            }
        },
        midClick: true
    });
};


// WEBPACK FOOTER //
// ./app/Resources/assets/default/js/modules/modal.js